var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.contextMenu,style:({ left: _vm.mouseX + 'px', top: _vm.mouseY + 'px' })},[_c('router-link',{class:_vm.$style.link,attrs:{"to":{
      name: 'advanced',
      query: {
        dateFrom: _vm.eventRange.day.from,
        dateTo: _vm.eventRange.day.to,
        computer: _vm.userId,
        logId: _vm.logId,
        filter: _vm.filter,
      },
    },"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('common.viewInTheEventStream'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }